import { MatchState } from '../../utils/tennisScore';
import { formatScore } from '../../utils/tennisScore';

interface Props {
  matchState: MatchState;
  playerLabel?: string;
  opponentLabel?: string;
}

export default function TennisBoardScore({ matchState, playerLabel = 'You', opponentLabel = 'CPU' }: Props) {
  const { gameScore, sets, currentSet, isDeuce } = matchState;

  const allSets = [...sets, currentSet];

  const playerInitial = playerLabel === 'You' ? 'YOU' : playerLabel;
  const opponentInitial = opponentLabel === 'CPU' ? 'CPU' : opponentLabel;

  return (
    <div className="bg-green-900 rounded-xl overflow-hidden text-white text-sm shadow-sm">
      {/* Header */}
      <div className="grid grid-cols-[1fr_auto_auto_auto] bg-green-800 px-3 py-1.5 text-xs text-green-300 font-medium uppercase tracking-wider">
        <div>Player</div>
        {allSets.map((_, i) => (
          <div key={i} className="w-10 text-center">S{i + 1}</div>
        ))}
        <div className="w-14 text-center">Game</div>
      </div>

      {/* Player Row */}
      <div className="grid grid-cols-[1fr_auto_auto_auto] items-center px-3 py-2 border-b border-green-800">
        <div className="flex items-center gap-2 font-semibold">
          <div className="w-7 h-7 flex items-center justify-center bg-lime-400 rounded-full text-green-900 font-bold text-xs">
            {playerInitial}
          </div>
          <span>{playerLabel}</span>
        </div>
        {allSets.map((s, i) => (
          <div
            key={i}
            className={`w-10 text-center font-bold ${
              i < sets.length
                ? s.player > s.opponent ? 'text-lime-400' : 'text-green-400'
                : 'text-white'
            }`}
          >
            {s.player}
          </div>
        ))}
        <div className="w-14 text-center">
          <span
            className={`inline-block px-2 py-0.5 rounded font-bold text-sm ${
              isDeuce ? 'bg-yellow-400 text-yellow-900' :
              gameScore.player === 'Ad' ? 'bg-lime-400 text-green-900' :
              'bg-green-700 text-white'
            }`}
          >
            {isDeuce ? 'Deuce' : formatScore(gameScore.player)}
          </span>
        </div>
      </div>

      {/* Opponent Row */}
      <div className="grid grid-cols-[1fr_auto_auto_auto] items-center px-3 py-2">
        <div className="flex items-center gap-2 font-semibold">
          <div className="w-7 h-7 flex items-center justify-center bg-orange-400 rounded-full text-white font-bold text-xs">
            {opponentInitial}
          </div>
          <span>{opponentLabel}</span>
        </div>
        {allSets.map((s, i) => (
          <div
            key={i}
            className={`w-10 text-center font-bold ${
              i < sets.length
                ? s.opponent > s.player ? 'text-orange-400' : 'text-green-400'
                : 'text-white'
            }`}
          >
            {s.opponent}
          </div>
        ))}
        <div className="w-14 text-center">
          <span
            className={`inline-block px-2 py-0.5 rounded font-bold text-sm ${
              isDeuce ? 'bg-yellow-400 text-yellow-900' :
              gameScore.opponent === 'Ad' ? 'bg-orange-400 text-white' :
              'bg-green-700 text-white'
            }`}
          >
            {isDeuce ? 'Deuce' : formatScore(gameScore.opponent)}
          </span>
        </div>
      </div>
    </div>
  );
}
